import _ from 'lodash';
import { type TextFieldValue } from '@gorilla/portal-shared/src/schemas';
import { type TextFieldDescriptor } from '@gorilla/portal-shared/src/types';
import { TextField as TextFieldMonday, Box } from '@vibe/core';
import { Paste, Apps } from '@vibe/icons';

type TextFieldProps = {
  value: TextFieldValue | undefined;
  fieldDescriptor: TextFieldDescriptor;
  onChange: (value: TextFieldValue | undefined) => void;
  onShowPlaceholdersModalClick: (insertHandler?: (placeholder: string) => void) => void;
};

export function TextField({ value, fieldDescriptor, onChange, onShowPlaceholdersModalClick }: TextFieldProps) {
  let normalizedValue: string;

  if (value === undefined || value === null) {
    normalizedValue = '';
  } else if (_.isNumber(value)) {
    normalizedValue = `${value}`;
  } else {
    normalizedValue = value as string;
  }

  const isNumber = fieldDescriptor.inputType === 'number';

  return (
    <Box className="section__field section__field--textfield">
      <TextFieldMonday
        type={isNumber ? 'number' : 'text'}
        size="medium"
        title={fieldDescriptor.title}
        placeholder={fieldDescriptor.placeholder ? fieldDescriptor.placeholder : ''}
        value={normalizedValue}
        onChange={(newValue: string) => {
          if (isNumber) {
            onChange(newValue ? +newValue : undefined);
            return;
          }
          onChange(newValue);
        }}
        icon={fieldDescriptor.placeholdersSupport ? Apps : undefined}
        onIconClick={
          fieldDescriptor.placeholdersSupport
            ? () => {
                onShowPlaceholdersModalClick((placeholder: string) => {
                  const base = normalizedValue ?? '';
                  const next = `${base}${placeholder}`;
                  onChange(next);
                });
              }
            : undefined
        }
      />
    </Box>
  );
}
